<template>
  <svg
    t="1713969429382"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="87930"
  >
    <path
      d="M840 148H184A56 56 0 0 0 128 204v616c0 30.88 25.12 56 56 56h656c30.88 0 56-25.12 56-56V204a56 56 0 0 0-56-56z m-38.016 112c0 7.68-3.136 14.72-8.224 19.776a27.904 27.904 0 0 1-47.744-19.776c0-7.68 3.136-14.72 8.224-19.776a27.904 27.904 0 0 1 47.744 19.776z m-112 0c0 7.68-3.136 14.72-8.224 19.776a27.904 27.904 0 0 1-47.744-19.776c0-7.68 3.136-14.72 8.224-19.776a27.904 27.904 0 0 1 47.744 19.776z m-159.744-19.776a27.904 27.904 0 0 1 47.744 19.776c0 7.68-3.136 14.72-8.224 19.776a27.904 27.904 0 0 1-47.744-19.776c0-7.68 3.136-14.72 8.224-19.776z m309.76 565.76c0 7.712-6.304 14.016-14.016 14.016H198.016a14.048 14.048 0 0 1-13.984-14.016V379.04a7.04 7.04 0 0 1 7.008-7.008H832.96a7.04 7.04 0 0 1 7.008 7.008v427.008z"
      fill="#3855EE"
      p-id="87931"
    ></path>
    <path
      d="M448.832 735.552a28 28 0 0 1-11.552-37.888l100.096-188.096a28.032 28.032 0 0 1 49.44 26.336l-100.192 188.096a27.904 27.904 0 0 1-37.792 11.552z m-113.152-52.224L282.144 629.76a28.032 28.032 0 0 1 0-39.616l53.536-53.568a3.488 3.488 0 0 1 4.992 0l34.656 34.656a3.488 3.488 0 0 1 0 4.992l-23.808 23.808a14.08 14.08 0 0 0 0 19.776l23.808 23.808a3.52 3.52 0 0 1 0 4.96l-34.656 34.656a3.424 3.424 0 0 1-4.992 0.096z m347.648 0L648.64 648.64a3.488 3.488 0 0 1 0-4.992l23.808-23.776a14.048 14.048 0 0 0 0-19.808l-23.808-23.776a3.488 3.488 0 0 1 0-4.992l34.656-34.656a3.488 3.488 0 0 1 4.992 0l53.536 53.568a28.032 28.032 0 0 1 0 39.616l-53.536 53.568a3.552 3.552 0 0 1-4.992-0.096z"
      fill="#29C287"
      p-id="87932"
    ></path>
  </svg>
</template>
